import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide03Funnel({
  index
}: SlideProps) {
  const stages = [{
    number: '1',
    title: 'TEASER',
    duration: '30 sec Snak™',
    purpose: 'Create curiosity',
    objective: 'Drive traffic',
    examples: ['Speaker introduction', 'Provocative question', 'Key statistic']
  }, {
    number: '2',
    title: 'EPISODES',
    duration: '5 min Snaks™',
    purpose: 'Deliver key learning moments',
    objective: 'High value actions',
    examples: ['Speaker highlights', 'Core educational messages', 'Visual storytelling']
  }, {
    number: '3',
    title: 'FULL WEBINAR',
    duration: '60 min replay',
    purpose: 'Deep educational engagement',
    examples: []
  }, {
    number: '4',
    title: 'CONTINUOUS NURTURE',
    duration: 'DERMX ecosystem',
    purpose: 'Keep HCPs returning',
    examples: []
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)]" data-id="element-54">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(2rem,4vw,3rem)]" data-id="element-55">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-56">
          The DERMX Content Funnel
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,4vw,3.5rem)] leading-[1.1]" data-id="element-57">
          <span className="text-[var(--brand-green-light)]" data-id="element-58">Build</span>{' '}
          anticipation.{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-59">Deliver</span>{' '}
          value. <span className="text-[var(--brand-green-light)]" data-id="element-60">Drive</span>{' '}
          deeper engagement.
        </h2>
      </motion.div>

      {/* Journey stages */}
      <div className="flex items-start gap-[clamp(1rem,2vw,2rem)] mb-[clamp(2rem,3vw,3rem)] overflow-x-auto pb-4" data-id="element-61">
        {stages.map((stage, idx) => <Fragment key={stage.number} data-id="element-62">
            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3 + idx * 0.1,
          duration: 0.5
        }} className="flex-shrink-0 w-[clamp(14rem,18vw,18rem)]" data-id="element-63">
              <div className="bg-[var(--surface)] rounded-2xl p-[clamp(1.25rem,2vw,2rem)] h-full" data-id="element-64">
                <div className="flex items-center gap-3 mb-[clamp(0.75rem,1.5vw,1.25rem)]" data-id="element-65">
                  <div className="w-8 h-8 rounded-full bg-[var(--brand-green)] flex items-center justify-center" data-id="element-66">
                    <span className="text-white font-bold text-sm" data-id="element-67">
                      {stage.number}
                    </span>
                  </div>
                  <h3 className="text-[var(--brand-green)] font-bold text-[clamp(0.875rem,1.25vw,1.125rem)] uppercase tracking-wide" data-id="element-68">
                    {stage.title}
                  </h3>
                </div>
                <p className="text-[var(--fg)] font-semibold text-[clamp(1rem,1.5vw,1.25rem)] mb-[clamp(0.5rem,1vw,0.75rem)]" data-id="element-69">
                  {stage.duration}
                </p>
                <p className="text-[var(--muted)] text-[clamp(0.875rem,1.25vw,1rem)] mb-[clamp(0.5rem,1vw,0.75rem)]" data-id="element-70">
                  <span className="font-semibold" data-id="element-71">Purpose:</span>{' '}
                  {stage.purpose}
                </p>
                {stage.objective && <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.25vw,1rem)] font-semibold mb-[clamp(0.75rem,1.5vw,1rem)]" data-id="element-72">
                    Objective: {stage.objective}
                  </p>}
                {stage.examples.length > 0 && <div className="text-[var(--muted)] text-[clamp(0.75rem,1.125vw,0.875rem)]" data-id="element-73">
                    <span className="font-semibold" data-id="element-74">Examples:</span>
                    <ul className="mt-1 space-y-1" data-id="element-75">
                      {stage.examples.map((ex, i) => <li key={i} data-id="element-76">• {ex}</li>)}
                    </ul>
                  </div>}
              </div>
            </motion.div>
            {idx < stages.length - 1 && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.5 + idx * 0.1,
          duration: 0.4
        }} className="flex-shrink-0 flex items-center pt-12" data-id="element-77">
                <ArrowRight className="w-6 h-6 text-[var(--brand-green)]" data-id="element-78" />
              </motion.div>}
          </Fragment>)}
      </div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8,
      duration: 0.6
    }} className="flex justify-between items-end" data-id="element-79">
        <p className="text-[var(--fg)] text-[clamp(1rem,1.75vw,1.5rem)] font-semibold" data-id="element-80">
          Each step naturally drives progression to the next.
        </p>
        <span className="text-[var(--muted)] text-sm" data-id="element-81">{index + 1}</span>
      </motion.div>
    </div>;
}